import { FileAttachment } from 'further-types/lp/ai-agent';

export const fileToBase64 = (file: File): Promise<string> =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => {
      if (typeof reader.result !== 'string') {
        reject(new Error('Unexpected FileReader result type'));
        return;
      }
      resolve(reader.result.split(',')[1]);
    };
    reader.onerror = reject;
    reader.readAsDataURL(file);
  });

export const getMediaType = (
  file: File,
): FileAttachment['mediaType'] | null => {
  const { type } = file;
  if (type === 'application/pdf') {
    return type;
  }
  return null;
};
